import { render, staticRenderFns } from "./SteelStructure.vue?vue&type=template&id=194ba0bf&scoped=true"
import script from "./SteelStructure.vue?vue&type=script&lang=js"
export * from "./SteelStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_babel-core@6.26.3_css-loader@6.11.0_webpack@5.100_4xpmdqc3iaixeru4y6alscik5i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ba0bf",
  null
  
)

export default component.exports